import { useLocalUserSettings } from '#pplx/frontend/apps/ask/user-settings/getLocalUserSettings.js';
import { useIsMobile } from '#pplx/frontend/platform-components/useMobileStyle.js';
import { useMemo } from 'react';
export function useSidebarPinned() {
    const { isMobileStyle } = useIsMobile();
    const [value, setValue, getValue] = useLocalUserSettings('isSidebarPinned', true);
    return useMemo(() => [isMobileStyle || value, setValue, getValue], [value, setValue, getValue, isMobileStyle]);
}
//# sourceMappingURL=useSidebarPinned.js.map